import { render, staticRenderFns } from "./PremiumCouponCard.vue?vue&type=template&id=9c7666a8&scoped=true"
import script from "./PremiumCouponCard.vue?vue&type=script&lang=js"
export * from "./PremiumCouponCard.vue?vue&type=script&lang=js"
import style0 from "./PremiumCouponCard.vue?vue&type=style&index=0&id=9c7666a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7666a8",
  null
  
)

export default component.exports